/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ManagerType = {
    SalesManager: 'SALES_MANAGER',
    CustomerSuccessManager: 'CUSTOMER_SUCCESS_MANAGER',
    FinopsManager: 'FINOPS_MANAGER'
} as const;
export type ManagerType = typeof ManagerType[keyof typeof ManagerType];


export function instanceOfManagerType(value: any): boolean {
    for (const key in ManagerType) {
        if (Object.prototype.hasOwnProperty.call(ManagerType, key)) {
            // @ts-ignore
            if (ManagerType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ManagerTypeFromJSON(json: any): ManagerType {
    return ManagerTypeFromJSONTyped(json, false);
}

export function ManagerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagerType {
    return json as ManagerType;
}

export function ManagerTypeToJSON(value?: ManagerType | null): any {
    return value as any;
}

